import { useEffect, useMemo, useState } from 'react';
import API from '../../../Utils/api';

import styles from './AthleteSearchPage.module.css';
import UserPreview from '../../../Components/UserPreview/UserPreview';
import Modal from '../../../Components/Modal/Modal';
import InviteAthleteModal from './InviteAthleteModal';

import { FaCheck, FaRegClock, FaSearch, FaUserPlus, FaPlus } from 'react-icons/fa';
import CreateAthleteModal from './CreateAthleteModal';
import InfoAthleteModal from './InfoAthleteModal';
import { useUser } from '../../../Context/useUser';
import { useParams } from 'react-router';
import { useVisitingUser } from '../../../Hooks/useVisitingUser';

export default function AthleteSearchPage() {
    const { user } = useUser();

    const { coachId } = useParams();

    const visitedUser = useVisitingUser(coachId);

    const currentUser = coachId ? visitedUser : user;

    const [relationships, setRelationships] = useState(null);
    const [search, setSearch] = useState('');

    const [inviteAthleteModal, setInviteAthleteModal] = useState(null);
    const [createAthleteModal, setCreateAthleteModal] = useState(null);
    const [infoAthleteModal, setinfoAthleteModal] = useState(null);

    const fetchAndSetRelationships = async currUser => {
        if (!currUser) return;
        const { data: relationships } = await API.getAthletesById(currUser._id);
        setRelationships(relationships.reverse());
    };

    useEffect(() => {
        fetchAndSetRelationships(currentUser);
    }, [currentUser]);

    const athleteIslands = useMemo(() => {
        if (!relationships) return [];
        const _search = search.toLowerCase();
        return relationships
            ?.filter(
                r =>
                    r.athlete.firstName?.toLowerCase().startsWith(_search) ||
                    r.athlete.lastName?.toLowerCase().startsWith(_search) ||
                    r.athlete.email?.toLowerCase().startsWith(_search) ||
                    r.athlete.type?.toLowerCase().startsWith(_search)
            )
            .map(relationship => (
                <div
                    key={relationship._id}
                    className={styles.athletePreview + ' island'}
                    onClick={
                        () => setinfoAthleteModal(relationship)
                        // relationship.status === 'Active' ? onAthleteClick(relationship.athlete) : ''
                    }
                >
                    <UserPreview
                        user={relationship.athlete}
                        statusIcon={
                            relationship.status === 'Active' ? (
                                <FaCheck color={'Green'} size={24} />
                            ) : (
                                <FaRegClock color={'Orange'} size={24} />
                            )
                        }
                    />
                </div>
            ));
    }, [relationships, search]);

    const createUserInviteModal = () => {
        if (!inviteAthleteModal) return null;

        return (
            <Modal
                closeCB={() => setInviteAthleteModal(false)}
                title={'Invite Athlete'}
                children={
                    <InviteAthleteModal
                        coachId={currentUser._id}
                        onClose={() => {
                            setRelationships([]);
                            fetchAndSetRelationships(currentUser);
                            setInviteAthleteModal(false);
                        }}
                    />
                }
            />
        );
    };

    const createCreationModal = () => {
        if (!createAthleteModal) return null;
        return (
            <Modal
                closeCB={() => setCreateAthleteModal(false)}
                title={'Create Athlete'}
                children={
                    <CreateAthleteModal
                        coachId={currentUser._id}
                        onClose={() => {
                            setRelationships([]);
                            fetchAndSetRelationships(currentUser);
                            setCreateAthleteModal(false);
                        }}
                    />
                }
            />
        );
    };

    const createInfoModal = () => {
        if (!infoAthleteModal) return null;

        return (
            <Modal
                closeCB={() => setinfoAthleteModal(false)}
                title={'Athlete'}
                children={
                    <InfoAthleteModal
                        relationship={infoAthleteModal}
                        onClose={() => {
                            setRelationships([]);
                            fetchAndSetRelationships(currentUser);
                            setinfoAthleteModal(false);
                        }}
                    />
                }
            />
        );
    };

    if (!relationships) return null;

    return (
        <div className={styles.wrap}>
            <div className={styles.header + ' island'}>
                <div className={styles.headerContent}>
                    <h2 className={styles.title}>My Athletes</h2>
                    <p className={styles.subtitle}>{relationships.length} athlete{relationships.length !== 1 ? 's' : ''} total</p>
                </div>
                <div className={styles.actions}>
                    <button className={styles.actionBtn + ' ' + styles.createBtn} onClick={() => setCreateAthleteModal(true)}>
                        <FaPlus />
                        <span>Create New</span>
                    </button>
                    <button className={styles.actionBtn + ' ' + styles.inviteBtn} onClick={() => setInviteAthleteModal(true)}>
                        <FaUserPlus />
                        <span>Add Existing</span>
                    </button>
                </div>
            </div>

            <div className={styles.searchContainer + ' island'}>
                <FaSearch className={styles.searchIcon} />
                <input
                    type='search'
                    onChange={u => setSearch(u.target.value)}
                    placeholder='Search athletes by name or email...'
                    className={styles.searchInput}
                    value={search}
                />
            </div>

            <div className={styles.athletesWrap}>{athleteIslands}</div>
            {createUserInviteModal()}
            {createCreationModal()}
            {createInfoModal()}
        </div>
    );
}
